// extracted by mini-css-extract-plugin
export default {"heading":"request-demo_heading__aXyM3","featurecolumn":"request-demo_featurecolumn__nCP7S","logo":"request-demo_logo__SZBUA","screen_wrapper":"request-demo_screen_wrapper__QSlb-"};